module.exports = __webpack_public_path__ + "static/media/springfield.a47134d3.jpg";